module.exports = __webpack_public_path__ + "5b52a3e0954322f7494f0c2039fd9e7e.svg";